import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { withTheme } from 'common/styling/theme';

import { staticStyles, getDynamicStyles } from './style';

const SearchBar = ({ theme, onChange, onInputChange, onEnter, placeholder, noLoupe, initValue }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  const [search, setSearch] = useState(typeof initValue !== 'undefined' ? initValue : '');

  useEffect(() => {
    if (typeof initValue !== 'undefined') {
      setSearch(initValue);
    }
  }, [initValue]);

  const handleChange = event => {
    setSearch(event.target.value);
    if (onInputChange) onInputChange(event.target.value);
  };

  const handleOnChange = searchValue => {
    if (onChange) onChange(searchValue);
    if (onEnter) onEnter(searchValue);
  };

  return (
    <div className="CRMSearchBar">
      <div className="CRMSearchBar__wrapper">
        <input
          className={`CRMSearchBar__input ${noLoupe && 'CRMSearchBar__input--noLoupe'} `}
          type="search"
          value={search}
          onKeyUp={event => {
            if (event.key === 'Enter' || (event.key === 'Backspace' && !event.target.value)) {
              handleOnChange(event.target.value);
            } else if (noLoupe) {
              handleOnChange(event.target.value);
            }
          }}
          onChange={handleChange}
          placeholder={placeholder || 'Search'}
        />
      </div>
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

SearchBar.propTypes = {
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  onEnter: PropTypes.func,
  theme: PropTypes.object,
};

SearchBar.defaultProps = {
  onChange: () => {},
  onInputChange: () => {},
  onEnter: () => {},
  theme: {},
};

export default withTheme()(SearchBar);
